import React, { FC } from 'react';
import translate from '../../translate';
import Select from '../../components/Select';

export interface ActiveVersionProps {
    data?: any;
    emailTemplateData?: any;
    updateSelectVersion: any;
}

const ActiveVersion: FC<ActiveVersionProps> = (props) => {
    let options = [];
    if (props?.emailTemplateData?.TEMPLATE?.versions) {
        options = props.emailTemplateData.TEMPLATE.versions.map((version: any) => ({
            label: `${version.name} (${version.updated_at})${version.active ? '(active)' : ''}`,
            value: version.id
        }));
    }

    const changeValue = (idVersion: any) => {
        props.updateSelectVersion(
            props?.emailTemplateData?.TEMPLATE?.versions.find((version: any) => version.id === idVersion)
        );
    };

    return (
        <Select
            label={translate('emailTemplateDetail.selectedVersion')}
            value={props.data?.id}
            options={options}
            onChange={changeValue}
            name='selectVersion'
        />
    );
};

export default ActiveVersion;
